import { toFeedback } from './to-feedback';

export const unknownErrorToFeedback = (err: unknown, feedback: HTMLParagraphElement) => {
    if (!(err instanceof Error)) {
        console.error(`Thrown object is not an instance of Error`, err);
        return;
    }

    if (`errors` in err && Array.isArray(err.errors)) {
        toFeedback(err.errors, feedback);
        return;
    }

    toFeedback([err.message], feedback);
};
